export const slug = "dashboard";
export const title = "Dashboard";
export const section = "Core";
export const content = `
# Dashboard

The Dashboard gives you an at-a-glance view of your food bank's activity for the current week.

## Metrics Cards

At the top of the page you'll find four key numbers:

- **Total Clients** — the total number of active client records in the system.
- **Monthly Visits** — how many visits have been logged so far this month.
- **Pending Approvals** — client-submitted profile changes that need staff review. Click this card to jump straight to the Pending Approvals queue.
- **Saturday Queue** — the number of clients currently in today's service queue.

## Visit Trend Chart

The chart below the cards shows daily visit counts over the last 30 days. Hover over any bar to see the exact count for that day. Peaks on Saturdays reflect your regular distribution schedule.

## Quick Check-In Button

The **Check In Client** button in the top-right launches the Saturday queue flow. Staff at the front door can use this to quickly add a client to the queue by scanning their ID or searching by name.

## Tips

- The pending-approval counter refreshes every 30 seconds automatically.
- If the dashboard shows stale data, a hard refresh (Ctrl+R / Cmd+R) will reload the latest figures.
`;
